import { render, staticRenderFns } from "./change-password.vue?vue&type=template&id=2324240d"
import script from "./change-password.vue?vue&type=script&lang=js"
export * from "./change-password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/nortonpigozzo/Development/nisoftwares/VeinsEnergia-api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2324240d')) {
      api.createRecord('2324240d', component.options)
    } else {
      api.reload('2324240d', component.options)
    }
    module.hot.accept("./change-password.vue?vue&type=template&id=2324240d", function () {
      api.rerender('2324240d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/components/change-password.vue"
export default component.exports